// COMMENT: Add TODOS
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "../api";
import {
  GET_SPECIALTIES_LOADING,
  GET_SPECIALTIES_SUCCESS,
  GET_SPECIALTIES_FAILURE,
} from "./types/specialties";

export const getSpecialties = () => async dispatch => {
  dispatch({ type: GET_SPECIALTIES_LOADING });

  try {
    const baseUrl = `${API_URL}/api/web/medical_specialty`;
    const pagination = `?pagination=200&orderBy=name&orderBy=description`;

    let URL = `${baseUrl}${pagination}`;

    const response = await axios.get(URL);

    dispatch({
      type: GET_SPECIALTIES_SUCCESS,
      payload: {
        data: [
          {
            value: "all",
            label: "TODOS",
          },
          ...response.data.data.map((item) => ({
            value: item.id,
            label: item.description,
          })),
        ],
      },
    });

    return response.status;
  } catch (error) {
    dispatch({ type: GET_SPECIALTIES_FAILURE });

    if (error.response && error.response.status === 422) {
      toast.error(error.response.data.message);
    } else {
      toast.error("Lo sentimos, ha sucedido un error inesperado.  (Error 00114");
    }
    return error.response.status;
  }
};
